export var APP_START = '@app/APP_START';
export var STORE_SCHEMAS = '@app/STORE_SCHEMAS';
export var SET_QUERY_READINESS = '@app/SET_QUERY_READINESS';
export var FETCH_PROJECT_DETAILS = '@app/FETCH_PROJECT_DETAILS';
export var FETCH_PROJECT_DETAILS_SUCCESS = '@app/FETCH_PROJECT_DETAILS_SUCCESS';
export var FETCH_PROJECT_DETAILS_ERROR = '@app/FETCH_PROJECT_DETAILS_ERROR';